import { type InsertMessageReaction, api } from '@here/api'

export const whenUpsertReaction = async (messageReaction: InsertMessageReaction) => {
	if (!messageReaction) return

	const { error, data } = await api()
		.from('message_reaction')
		.upsert(messageReaction, {
			onConflict: 'message_id,created_by',
		})
		.select()
		.single()

	if (error) throw new Error('Failed to upsert reaction')

	return data
}
